import { Check } from "lucide-react";

const STEPS = [
  { key: "awaiting_upload", label: "Awaiting Upload" },
  { key: "submitted", label: "Submitted" },
  { key: "in_review", label: "In Review" },
  { key: "completed", label: "Completed" },
];
const ORDER = STEPS.map((s) => s.key);

export default function StatusTimeline({ status }) {
  // treat "in_progress" (uploads started, not submitted) as awaiting_upload
  const current = ORDER.indexOf(status === "in_progress" ? "awaiting_upload" : (status || "awaiting_upload"));
  return (
    <ol className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="status-timeline">
      {STEPS.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={s.key} className={`p-4 border ${done ? "border-[#2A5BFF]/60 bg-[#2A5BFF]/[0.04]" : active ? "border-[#2A5BFF]" : "border-white/10"}`} data-testid={`timeline-step-${s.key}`}>
            <div className="flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-white/40">
              <span>{String(i + 1).padStart(2, "0")}</span>
              {done && <Check size={12} className="text-[#2A5BFF]" />}
            </div>
            <div className={`mt-2 font-anton uppercase text-lg leading-none ${done || active ? "text-white" : "text-white/40"}`}>{s.label}</div>
          </li>
        );
      })}
    </ol>
  );
}
